import { gql } from "@apollo/client";


export const GET_DELEGACION_PRELIQUIDACION = gql`
    query delegacionesConProfesionalesActivosByIdTipoProfesional($idTipoProfesional: Int!, $mes: Int!, $anio: Int!) {
        delegacionesConProfesionalesActivosByIdTipoProfesional(idTipoProfesional: $idTipoProfesional, mes: $mes, anio: $anio) {
            idDelegacion,
            idRegion,
            cod_Delegacion,
            descripcion
        }
    }
`;